<div class="wrapper">
    <div class="box w-full">
        <p class="px-8 py-4 text-nowrap flex items-center">...{{ 'common.loading' | translate }}...</p>
        <mat-progress-bar mode="query"></mat-progress-bar>
    </div>
</div>